import { CLOUDFRONT_URL } from "config/constants";
import type { TrainingPicture } from "types/TrainingPicture";

export const getDefaultStudentProfilePicture = (
  currentProfilePicture: string | null,
  trainingPictures: TrainingPicture[],
): string | null => {
  if (currentProfilePicture) return null;

  return (
    trainingPictures.find((picture) => picture.is_usable)?.original_picture ??
    null
  );
};

export const getRelativeProfilePicturePath = (pictureUrl: string): string => {
  if (CLOUDFRONT_URL && pictureUrl.startsWith(CLOUDFRONT_URL)) {
    return pictureUrl.substring(CLOUDFRONT_URL.length);
  }
  return pictureUrl;
};
